import { createApi } from '@reduxjs/toolkit/query/react';
import { getBaseQuery } from './getBaseQuery';
import { DeleteDepositRequest, DeleteDepositResponse, DuplicateDepositRequest, DuplicateDepositResponse, GetDepositRequest, GetDepositResponse, GetDepositSelectorRequest, GetDepositSelectorResponse, GetDepositTypeRequest, GetDepositTypeResponse, GetDepositUuidRequest, GetDepositUuidResponse, PatchDepositRequest, PatchDepositResponse, PostDepositRequest, PostDepositResponse } from './types/TDepositServices';

const URL_Prefix = '/deposit';

export const depositService = createApi({
    reducerPath: 'depositService',
    baseQuery: getBaseQuery,
    tagTypes: ['Deposit'],
    endpoints: (builder) => ({
        getDeposit: builder.query<GetDepositResponse, GetDepositRequest>({
            query: (params) => ({
                url: `${URL_Prefix}/`,
                method: 'GET',
                params: params,
            }),
            //@ts-ignore
            invalidatesTags: ['Deposit'],
        }),
        postDeposit: builder.mutation<PostDepositResponse, PostDepositRequest>({
            query: (body) => ({
                url: `${URL_Prefix}/`,
                method: 'POST',
                body: body
            }),
            invalidatesTags: ['Deposit'],
        }),
        patchDeposit: builder.mutation<PatchDepositResponse, PatchDepositRequest>({
            query: (body) => ({
                url: `${URL_Prefix}/${body.uuid}/`,
                method: 'PATCH',
                body: body
            }),
            invalidatesTags: ['Deposit'],
        }),
        getDepositUuid: builder.query<GetDepositUuidResponse, GetDepositUuidRequest>({
            query: (params) => ({
                url: `${URL_Prefix}/${params.uuid}/`,
                method: 'GET',
                params: params,
            }),
            //@ts-ignore
            invalidatesTags: ['Deposit'],
        }),
        getDepositType: builder.query<GetDepositTypeResponse, GetDepositTypeRequest>({
            query: (params) => ({
                url: '/deposit_type/selector/',
                method: 'GET',
                params: params,
            }),
        }),
        duplicateDeposit: builder.mutation<DuplicateDepositResponse, DuplicateDepositRequest>({
            query: (body) => ({
                url: `${URL_Prefix}/${body.uuid}/duplicate/`,
                method: 'POST',
                body: body
            }),
            invalidatesTags: ['Deposit'],
        }),
        getDepositSelector: builder.query<GetDepositSelectorResponse, GetDepositSelectorRequest>({
            query: (params) => ({
                url: `${URL_Prefix}/selector/`,
                method: 'GET',
                params: params,
            }),
        }),
        deleteDeposit: builder.mutation<DeleteDepositResponse, DeleteDepositRequest>({
            query: (body) => ({
                url: `${URL_Prefix}/${body.uuid}/cascade/`,
                method: 'DELETE',
            }),
            invalidatesTags: ['Deposit'],
        }),
    }),
});

// Экспортируем все хуки, включая useLazySendCodeQuery
export const {
    useGetDepositQuery,
    useLazyGetDepositQuery,
    usePostDepositMutation,
    useGetDepositUuidQuery,
    useLazyGetDepositUuidQuery,
    useGetDepositTypeQuery,
    useLazyGetDepositTypeQuery,
    usePatchDepositMutation,
    useDuplicateDepositMutation,
    useGetDepositSelectorQuery,
    useLazyGetDepositSelectorQuery,
    useDeleteDepositMutation
} = depositService;